<template>
  <transition name="modal">
    <div class="modal-mask" @click="onModalClick">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-close-wrapper" @click="onClose" >
            <Close class="modal-close" />
          </div>
          <div class="otto-booking-wrapper otto-booking-wrapper-client">
            <div class="otto-client-finder" v-if="!this.editMode">
              <p class="otto-client-finder__title">Find Client</p>
              <ClientSearch />
            </div>
            <div id="patient-info-wrapper" class="col-12">
              <div class="col-12 pb-title" :class="{'pb-title--main': this.editMode}">Client Information</div>
              <div class="input-wrapper">
                <label class="otto-label otto-label--required" for="first-name">First Name:</label>
                <span class="star"> *</span><br>
                <input
                  class="otto-input" name="firstName" type="text"
                  :disabled="this.disableInput"
                  placeholder="First Name" v-model="form.firstName"
                  @focus="$v.form.firstName.$reset()"
                  v-bind:class="{ 'otto-input-error': $v.form.firstName.$error }"
                >
                <span v-if="$v.form.firstName.$error" class="otto-text-error">First name is required.</span>
              </div>
              <div class="input-wrapper">
                <label class="otto-label otto-label--required" for="last-name">Last Name:</label>
                <span class="star"> *</span><br>
                <input
                  class="otto-input" name="lastName" type="text"
                  :disabled="this.disableInput"
                  placeholder="Last Name"
                  v-model="form.lastName"
                  @focus="$v.form.lastName.$reset()"
                  v-bind:class="{ 'otto-input-error': $v.form.lastName.$error }"
                >
                <span v-if="$v.form.lastName.$error" class="otto-text-error">Last name is required.</span>
              </div>
              <div class="input-wrapper">
                <label class="otto-label otto-label--required" for="phone-number">Primary Phone Number:</label><span class="star"> *</span><br>
                <input
                  :disabled="this.disableInput"
                  class="otto-input"
                  name="phoneNumber"
                  type="tel"
                  placeholder="(888)-123-4567"
                  pattern="^([0-9]{3})-([0-9]{3})-([0-9]{4})$"
                  @keyup="onPhoneNumberInput"
                  v-model="form.phoneNumber"
                  @focus="$v.form.phoneNumber.$reset()"
                  v-bind:class="{ 'otto-input-error': $v.form.phoneNumber.$error }"
                >
                <span v-if="$v.form.phoneNumber.$error" class="otto-text-error">Please provide a valid phone number.</span>
              </div>
              <div class="input-wrapper">
                <label class="otto-label" for="email">Email Address:</label><br />
                <input
                  :disabled="this.disableInput"
                  class="otto-input"
                  name="email"
                  type="email"
                  placeholder="someone@example.com"
                  v-model="form.email"
                  @focus="$v.form.email.$reset()"
                  v-bind:class="{ 'otto-input-error': $v.form.email.$error }"
                />
                <span v-if="$v.form.email.$error" class="otto-text-error">Please provide a valid email address.</span>
              </div>
              <div class="input-wrapper">
                <label class="otto-label">Notes:</label><br>
                <textarea class="otto-textarea" v-model="form.notes"></textarea>
              </div>
            </div>
          </div>
          <div class="otto-booking-wrapper otto-booking--appointment">
            <div class="col-12 pb-title">Appointment</div>
            <div class="input-wrapper">
              <label class="otto-label otto-label--required">Appointment type</label>
              <span class="star"> *</span><br>
              <select
                class="pb-select"
                v-model="form.type"
                v-bind:class="{ 'otto-input-error otto-input-error--select': $v.form.type.$error }"
                @focus="$v.form.type.$reset()"
              >
                <option v-for="appointmentType in appointmentTypes" v-bind:value="appointmentType._id">
                  {{ appointmentType.name }}
                </option>
              </select>
              <span v-if="$v.form.type.$error" class="otto-text-error">Please select an appointment type</span>
            </div>
            <div class="input-wrapper">
              <label class="otto-label" for="reason">Appointment Reason:</label>
              <input class="otto-input" name="reason" type="text" v-model="form.description" />
            </div>
          </div>
          <div class="input-wrapper">
            <label class="otto-label otto-label--required">Date</label>
            <span class="star"> *</span><br>
            <p class="otto-date-title" @click="onDayClick">{{formattedCurrentDay}}</p>
            <div class="pb-booking-calendar" v-show="showCalendar">
              <full-calendar ref="booking-calendar" :config="calendarConfig" />
            </div>
          </div>
          <div class="input-wrapper otto-input-wrapper--time">
            <div>
              <label class="otto-label otto-label--required">Available time</label>
              <span class="star"> *</span>
            </div>
            <div class="otto-checkbox-wrapper">
              <input type="checkbox" id="otto-appointment-overlap" class="otto-checkbox" v-model="showOverlaps"><label for="otto-appointment-overlap">Show Overlapping Appointments</label>
            </div>
          </div>
          <div class="otto-timeslots">
              <pulse-loader :loading="loading" :color="'#843CAE'" :size="'24px'" class="otto-booking-loader"></pulse-loader>
              <p v-if="noApps && !showOverlaps" class="otto-booking-no-apps">No available appointments for that day.</p>
              <div  class="otto-btn" v-for="slot in slotsToShow" :class="{'active': slot === selectedSlot}" @click="onSlotClick(slot)">
                <span class="otto-btn-text">{{formattedTimeSlot(slot.start_time)}}</span>
              </div>
          </div>
          <div class="otto-booking__book" v-if="selectedSlot">
            <p class="pb-title">{{appointmentTime}}</p>
            <button :disabled="submitting || (loading && !notificationMode)" class="otto-btn otto-btn--book" :class="{'otto-btn--disabled': submitting || (loading && !notificationMode)}" @click="onBookClick">
              <span class="otto-btn-text">{{submitText}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import moment from 'moment-timezone';
import { mapState, mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { ADD_TOAST_MESSAGE } from 'vuex-toast';
import {
  required,
  email,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators';
import PulseLoader from '@/components/Loader';
import Close from '@/components/Cancel.svg';
import ClientSearch from '@/components/ClientSearch';
import { formatPhoneNumber, stripPhoneNumber, debounce, getDayFromCalendarDate } from '@/utils';


export default {
  name: 'booking',
  components: {
    Close,
    ClientSearch,
    PulseLoader,
  },
  mounted() {
    this.onResize = debounce(this.setHeight, 200);
    window.addEventListener('resize', this.onResize);
    this.$el.querySelector('.modal-container').style.height = `${parseInt(window.innerHeight * 0.85, 10)}px`;
    if (this.editMode) {
      this.updateForm(this.client);
      this.form.description = this.description;
      this.form.notes = this.notes;
    } else {
      this.setCurrentDay(this.currentCalendarDay);
      this.setDefaultAppointmentType();
    }
    this.form.type = this.type._id || this.type;
    this.setOverlappingSlots(this.form.type);
    this.setOriginalForm();
    this.highlightDate(this.currentDay);
  },
  destroyed() {
    this.clearBooking();
    window.removeEventListener('resize', this.onResize);
  },
  validations() {
    if (this.client._id) {
      return {
        form: {
          type: {
            required,
          },
          email: {
            email,
          },
          firstName: {},
          lastName: {},
          phoneNumber: {},
        },
      };
    }
    return {
      form: {
        type: {
          required,
        },
        email: {
          email,
        },
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        phoneNumber: {
          minLength: minLength(14),
          maxLength: maxLength(14),
          required,
        },
      },
    };
  },
  data() {
    return {
      showCalendar: false,
      loading: false,
      submitting: false,
      noApps: false,
      originalForm: {},
      form: {
        email: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        type: null,
        notes: '',
        description: '',
      },
      calendarConfig: {
        timezone: this.currentTimezone,
        defaultView: 'month',
        editable: false,
        selectable: false,
        contentHeight: 'auto',
        fixedWeekCount: false,
        buttonIcons: {
          prev: 'otto-icon-prev',
          next: 'otto-icon-next',
        },
        header: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
        dayClick: (date) => {
          this.updateCurrentDay(moment.utc(date));
          this.selectSlot(null);
          this.loadAppointmentsForDay();
          this.toggleCalendar();
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      'enableClientForm', 'currentTimezone', 'notificationMode',
    ]),
    ...mapState({
      appointmentTypes: state => state.appointmentTypes.list,
      currentCalendarDay: state => state.appointment.currentCalendarDay,
      currentDay: state => state.booking.currentDay,
      availableSlots: state => state.booking.availableSlots,
      overlappingSlots: state => state.booking.overlappingSlots,
      selectedSlot: state => state.booking.selectedSlot,
      editMode: state => state.booking.editMode,
      client: state => state.booking.client,
      type: state => state.booking.appointment.type,
      notes: state => state.booking.appointment.notes,
      description: state => state.booking.appointment.description,
    }),
    ...mapFields({
      showOverlaps: 'showOverlaps',
    }),
    appointmentTime() {
      if (this.selectedSlot) {
        return this.selectedSlot.start_time.format('dddd, MMMM Do YYYY @ h:mm a');
      }
      return `${moment.parseZone(this.currentDay).format('dddd, MMMM Do YYYY')}`;
    },
    formattedCurrentDay() {
      if (this.selectedSlot) {
        return this.selectedSlot.start_time.format('dddd, MMMM Do YYYY, h:mm a');
      }
      return moment.parseZone(this.currentDay).format('dddd, MMMM Do YYYY');
    },
    slotsToShow() {
      if (this.showOverlaps) {
        return this.overlappingSlots;
      }
      return this.availableSlots;
    },
    submitText() {
      if (this.editMode && !this.notificationMode) {
        return 'CHANGE';
      }
      return 'BOOK';
    },
    hasChanges() {
      let hasChanged = false;

      // in edit mode compare with original form
      if (this.editMode) {
        Object.entries(this.form).forEach((entry) => {
          if (entry[1] !== this.originalForm[entry[0]]) {
            hasChanged = true;
          }
        });

        // check for selected time change as well
        if (!this.selectedSlot ||
            (this.originalForm.selectedSlot &&
            !this.selectedSlot.start_time.isSame(this.originalForm.selectedSlot.start_time))) {
          hasChanged = true;
        }

        return hasChanged;
      }

      // just check if form is edited
      Object.entries(this.form).forEach((entry) => {
        if (entry[0] !== 'type' && entry[1] !== '') {
          hasChanged = true;
        }
      });
      return hasChanged;
    },
    apiCall() {
      if (this.editMode && !this.notificationMode) {
        return this.updateAppointment;
      }

      return this.bookAppointment;
    },
    successText() {
      const bookTxt = 'Appointment booked successfully.';
      const updateTxt = 'Appointment changed successfully.';

      if (this.editMode && !this.notificationMode) {
        return updateTxt;
      }
      return bookTxt;
    },
    disableInput() {
      return this.editMode && (!this.enableClientForm || !this.notificationMode);
    },
  },
  watch: {
    client: {
      handler(newValue, oldValue) {
        if (newValue === {}) {
          this.$v.$reset();
          this.clearForm();
          return;
        }

        if (newValue._id !== oldValue._id) {
          this.updateForm(newValue);
        }
      },
      deep: true,
    },
    type: {
      handler(newValue) {
        this.form.type = newValue._id || newValue;
      },
    },
    'form.type': {
      handler() {
        this.loadAppointmentsForDay();
        this.setOverlappingSlots(this.form.type);
      },
    },
    notes: {
      handler(newValue) {
        this.form.notes = newValue;
      },
    },
    description: {
      handler(newValue) {
        this.form.description = newValue;
      },
    },

  },
  methods: {
    ...mapActions([
      'toggleBooking',
      'closeBooking',
      'setCurrentDay',
      'getAvailableAppointments',
      'bookAppointment',
      'updateAppointment',
      'clearBooking',
      'selectSlot',
      'setClient',
      'setAppointmentType',
      'setFormData',
      'setAppointmentDetails',
      'changeAppointment',
      'addAppointment',
      'setOverlappingSlots',
      'setDefaultAppointmentType',
      'updateSelectedSlot',
      'setCurrentCalendarDay',
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE,
    }),
    setHeight() {
      this.$el.querySelector('.modal-container').style.height = `${parseInt(window.innerHeight * 0.85, 10)}px`;
    },
    onClose() {
      if (!this.submitting) {
        if (this.hasChanges) {
          this.showCloseModal();
        } else {
          this.closeBooking();
        }
      }
    },
    setOriginalForm() {
      if (this.editMode) {
        this.originalForm = { ...this.form };
        if (this.selectedSlot) {
          this.originalForm.selectedSlot = { ...this.selectedSlot };
        }
      }
    },
    showCloseModal() {
      this.$modal.show('dialog', {
        text: 'Discard changes?',
        buttons: [{
          title: 'Cancel',
        }, {
          title: 'Close',
          default: true,
          handler: this.onModalClose,
        }],
      });
    },
    onModalClose() {
      this.$modal.hide('dialog');
      this.closeBooking();
    },
    onModalClick(e) {
      if (!e.target.classList.contains('modal-wrapper')) {
        return false;
      }
      this.onClose();
      return true;
    },
    toggleCalendar() {
      this.showCalendar = !this.showCalendar;
    },
    onDayClick() {
      this.toggleCalendar();
    },
    formattedTimeSlot(time) {
      return moment.tz(time, this.currentTimezone).format('h:mm a');
    },
    formatPhoneNumber(input) {
      return formatPhoneNumber(stripPhoneNumber(input));
    },
    onPhoneNumberInput(event) {
      let output;
      const input = this.form.phoneNumber.replace(/[^0-9]/g, '');
      output = this.formatPhoneNumber(input);
      if (event.key === 'Backspace') {
        const lastChar = output.charAt(output.length - 1);
        if (lastChar === '-') {
          output = output.substring(0, output.length - 1);
        }
        if (lastChar === ')') {
          output = output.slice(0, output.length - 2) + output.slice(output.length - 1);
        }
      }
      this.form.phoneNumber = output;
    },
    clearForm() {
      this.form.email = '';
      this.form.firstName = '';
      this.form.lastName = '';
      this.form.phoneNumber = '';
    },
    updateForm(client) {
      this.form.email = client.email;
      this.form.firstName = client.first_name;
      this.form.lastName = client.last_name;
      this.form.phoneNumber = this.formatPhoneNumber(client.phone_number);
    },
    onSlotClick(slot) {
      if (this.selectedSlot === slot) {
        this.selectSlot(null);
      } else {
        this.selectSlot(slot);
      }
    },
    onBookClick() {
      if (this.$v.form.$invalid) {
        this.$v.form.$touch();
        this.$nextTick(() => {
          this.$el.querySelector('.otto-input-error').scrollIntoView({
            behavior: 'smooth',
          });
        });
      } else {
        if (!this.client._id) {
          this.setFormData(this.form);
        } else {
          this.setAppointmentDetails(this.form);
        }
        this.submitAppointment();
      }
    },
    submitAppointment() {
      if (this.submitting) {
        return false;
      }
      this.submitting = true;
      const text = this.successText;
      return this.apiCall()
        .then(() => {
          this.setCurrentCalendarDay(this.currentDay);
          this.toggleBooking();
          this.addToast({
            text,
            type: 'success',
          });
          this.submitting = false;
        })
        .catch((err) => {
          this.addToast({
            text: err.message,
            type: 'danger',
          });
          this.submitting = false;
        });
    },
    loadAppointmentsForDay() {
      this.loading = true;
      this.getAvailableAppointments(this.form.type)
        .then((apps) => {
          this.loading = false;
          if (apps.length === 0) {
            this.noApps = true;
          } else {
            this.noApps = false;
          }

          if (this.selectedSlot) {
            this.updateSelectedSlot();
          }
        });
    },
    removeHighlightedDate() {
      const highightedItems = this.$el.querySelectorAll('.otto-calendar-date--selected');
      Array.prototype.forEach.call(highightedItems, item => item.classList.remove('otto-calendar-date--selected'));
    },
    highlightDate(date) {
      this.removeHighlightedDate();
      const newDate = moment(date);
      const newSelector = `[data-date="${newDate.format('YYYY-MM-DD')}"]`;
      const itemsToHighlight = this.$el.querySelectorAll(newSelector);

      Array.prototype.forEach.call(itemsToHighlight, item => item.classList.add('otto-calendar-date--selected'));
    },
    updateCurrentDay(date) {
      this.setCurrentDay(getDayFromCalendarDate(date));
      this.highlightDate(date);
      this.setOverlappingSlots(this.form.type);
    },
  },
};
</script>

<style lang="sass" src="@/assets/styles/booking.sass">
</style>



// WEBPACK FOOTER //
// src/components/Booking.vue